import { render, staticRenderFns } from "./CompanyDeleteAutoTime.vue?vue&type=template&id=6b124776&scoped=true"
import script from "./CompanyDeleteAutoTime.vue?vue&type=script&lang=js"
export * from "./CompanyDeleteAutoTime.vue?vue&type=script&lang=js"
import style0 from "./CompanyDeleteAutoTime.vue?vue&type=style&index=0&id=6b124776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b124776",
  null
  
)

export default component.exports